import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CombinationOP, ProductsResponseOP } from '@cemex-core/cmx-api';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  ProductsActions,
  ProductsActionTypes,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/products.actions';

export interface State extends EntityState<CombinationOP> {
  selectedCombinationId: number | null;
}

export const adapter: EntityAdapter<CombinationOP> = createEntityAdapter<CombinationOP>({
  selectId: (_combination: CombinationOP) => _combination.combinationId,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedCombinationId: null,
});

export function reducer(state = initialState, action: ProductsActions | OrderBuilderActions): State {
  switch (action.type) {
    case ProductsActionTypes.LOAD_COMPLETE: {
      const payload: ProductsResponseOP = action.payload;
      const combinations = payload.combinations;
      return adapter.addMany(combinations, adapter.removeAll(state));
    }
    case RESET_BUILDER:
    case ProductsActionTypes.RESET: {
      return adapter.removeAll(state);
    }
    case ProductsActionTypes.LOAD:
    default:
      return state;
  }
}
